module.exports = __webpack_public_path__ + "static/media/whitelogo.0d56446a.png";